//Migration are used when you want to persist old state and mutate new state
export default {
  // eslint-disable-next-line
  0: (state: any) => {
    return {
      ...state
    };
  }
};
